export default {
    /** @param {import('vue').VueConstructor} app */
    install(app, options) {
        app.prototype.$services = options.globalHandle.services;
    }
};
